import { useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DAILY_LIMIT_MSG =
  "You've reached today's limit of 20 free messages. Saathi resets every day, so please come back tomorrow. If it's urgent, call 2-1-1 for free help, or 9-1-1 in an emergency.";

export function getClientId() {
  let id = localStorage.getItem("saathi_cid");
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("saathi_cid", id);
  }
  return id;
}

export const isDailyLimit = (e) => e?.response?.status === 429 && e?.response?.data?.detail === "daily_limit";

export function useOrgName(slug) {
  const [name, setName] = useState(null);
  useEffect(() => {
    if (!slug) return;
    axios.get(`${API}/orgs/${slug}`).then((r) => setName(r.data.name)).catch(() => setName(null));
  }, [slug]);
  return name;
}

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const authApi = axios.create({ baseURL: API, withCredentials: true });
